module.exports = __webpack_public_path__ + "img/14.476cab91.jpg";